export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1880dc4c1b3190398620370e0b1ed1fb9a96513d&name=fetchTypeahead!'